import { parseISO, isValid } from 'date-fns';

export function parseDateValue(rawDate: unknown): Date | null {
    if (!rawDate) {
        return null;
    }

    if (rawDate instanceof Date) {
        return isValid(rawDate) ? rawDate : null;
    }

    if (typeof rawDate === 'number') {
        const date = new Date(rawDate);
        return isValid(date) ? date : null;
    }

    if (typeof rawDate === 'string') {
        // Check for ISO
        let date = parseISO(rawDate);
        if (isValid(date)) {
            return date;
        }

        // Find the "MM/DD/YYYY" part at the start of the string
        // Ignores the time and problematic timezone (e.g. AEST)
        const match = rawDate.match(/^(\d{1,2}\/\d{1,2}\/\d{4})/);
        if (match && match[1]) {
            const [month = '', day = '', year = ''] = match[1].split('/');

            if (month && day && year) {
                // Construct a predictable ISO string and parse it.
                const isoString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00.000Z`;
                date = parseISO(isoString);
                if (isValid(date)) {
                    return date;
                }
            }
        }

        // Strips timezones like AEST/EDT
        const strippedInput = rawDate.replace(/\s[A-Z]{3,5}$/, '');
        date = new Date(strippedInput);
        if (isValid(date)) {
            return date;
        }

        // Try parsing the whole string
        date = new Date(rawDate);
        if (isValid(date)) {
            return date;
        }
    }

    // All parsing attempts failed
    return null;
}
